module.exports = __webpack_public_path__ + "img/one2.d70667d3.jpg";